import React from "react";
import "../styles/App.scss";

function Blogs() {
  return (
    <div className="page">
      <div className="main">
        <div className="container">
          <div className="row">
            <h3>
              This page is coming soon{" "}
              <span role="img" aria-label="emoji">
                😉
              </span>
            </h3>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Blogs;
